export default defineAppConfig({
	myLayer: {
		name: 'Fysio Layer',
	},
});

declare module '@nuxt/schema' {
	interface AppConfigInput {
		myLayer?: {
			/** Project name */
			name?: string;
		};
	}
}
